module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"10\">\n  <path d=\"M6 0h19v2H6zM0 8h25v2H0z\"/>\n</svg>";